import React from 'react';

import { ClassName, I18nText, IsDisabled } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import { GlobalCompanyTabCompanyType } from '../../../globalCompanyTabsTypes';

import { CreateGlobalCompanyTabForm } from '../../forms/CreateGlobalCompanyTabForm';

import { SimpleModalButton } from '../../../../../helpers/buttons/SimpleModalButton';

import { words } from '../../../../../locales/keys';

interface CreateGlobalCompanyTabModalButtonProps {
  companyType: GlobalCompanyTabCompanyType;
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: string;
  disabled?: IsDisabled;
}

const CREATE_GLOBAL_COMPANY_TAB_FORM = 'create-global-company-tab-form';
const CREATE_GLOBAL_COMPANY_TAB_BUTTON = 'create-global-company-tab-button';

function CreateGlobalCompanyTabModalButton({
  companyType,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  disabled
}: CreateGlobalCompanyTabModalButtonProps) {
  return (
    <SimpleModalButton
      className={className}
      dataGa={CREATE_GLOBAL_COMPANY_TAB_BUTTON}
      disabled={disabled}
      i18nTextClassName={i18nTextClassName}
      i18nText={i18nText}
      i18nTitle={words.createCustomTab}
      icon={icon}
      iconClassName={iconClassName}
      withoutButtons
      withoutChildrenWrapper
      withoutInitialFocus
    >
      {({ hideModal }) => (
        <CreateGlobalCompanyTabForm
          companyType={companyType}
          hideModal={hideModal}
          form={CREATE_GLOBAL_COMPANY_TAB_FORM}
        />
      )}
    </SimpleModalButton>
  );
}

export default CreateGlobalCompanyTabModalButton;
